import { Check, SkipForward, Pencil, Trash2, Clock, MapPin } from "lucide-react";
import { listOf } from "@/lib/api";

const urgencyStyles = {
  high: "border-l-[5px] border-l-[#991B1B]",
  medium: "border-l-[5px] border-l-[#365458]",
  low: "border-l-[5px] border-l-zinc-300",
};

export const TaskCard = ({ task, onComplete, onSkip, onEdit, onDelete, compact }) => {
  const done = task.status === "done";
  const skipped = task.status === "skipped";
  return (
    <div
      data-testid={`task-card-${task.id}`}
      className={`bg-zinc-100 rounded-2xl p-4 shadow-md ${urgencyStyles[task.urgency] || ""} ${
        done || skipped ? "opacity-50" : ""
      }`}
    >
      <div className="flex items-start gap-3">
        {onComplete && (
          <button
            data-testid={`task-complete-${task.id}`}
            onClick={() => onComplete(task)}
            className={`mt-0.5 w-7 h-7 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
              done ? "bg-[#365458] border-[#365458]" : "border-zinc-400 hover:border-[#365458]"
            }`}
          >
            {done && <Check className="w-4 h-4 text-white" strokeWidth={3} />}
          </button>
        )}
        <div className="flex-1 min-w-0">
          <p className={`text-zinc-900 font-semibold leading-snug ${done || skipped ? "line-through" : ""}`}>
            {task.title}
          </p>
          {task.notes && !compact && (
            <p className="text-sm text-zinc-500 mt-1">{task.notes}</p>
          )}
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2 text-xs text-zinc-500">
            <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" />{task.estimated_minutes}m</span>
            <span className="inline-flex items-center gap-1 capitalize"><MapPin className="w-3 h-3" />{listOf(task, "locations", "location").join(" · ")}</span>
            {listOf(task, "categories", "category").map((c) => (
              <span key={c} className="px-2 py-0.5 rounded-full bg-zinc-200 text-zinc-600">{c}</span>
            ))}
            {skipped && <span className="text-zinc-400">skipped</span>}
          </div>
        </div>
      </div>
      {(onSkip || onEdit || onDelete) && !done && !skipped && (
        <div className="flex gap-2 mt-3 pt-3 border-t border-zinc-200">
          {onSkip && (
            <button data-testid={`task-skip-${task.id}`} onClick={() => onSkip(task)}
              className="flex-1 inline-flex items-center justify-center gap-1 text-xs font-medium text-zinc-500 py-1.5 rounded-lg hover:bg-zinc-200">
              <SkipForward className="w-3.5 h-3.5" /> Skip
            </button>
          )}
          {onEdit && (
            <button data-testid={`task-edit-${task.id}`} onClick={() => onEdit(task)}
              className="flex-1 inline-flex items-center justify-center gap-1 text-xs font-medium text-zinc-600 py-1.5 rounded-lg hover:bg-zinc-200">
              <Pencil className="w-3.5 h-3.5" /> Edit
            </button>
          )}
          {onDelete && (
            <button data-testid={`task-delete-${task.id}`} onClick={() => onDelete(task)}
              className="flex-1 inline-flex items-center justify-center gap-1 text-xs font-medium text-[#991B1B] py-1.5 rounded-lg hover:bg-red-50">
              <Trash2 className="w-3.5 h-3.5" /> Delete
            </button>
          )}
        </div>
      )}
    </div>
  );
};
